export default __webpack_public_path__ + "static/media/finance.85bc75a7.png";